import { LoadOption } from "./load-options";

export interface ILoadOption {
    loadOption: LoadOption;
}
